import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useLocale } from '../../../Shared/locale';
import { Payment } from '../../../Shared/types';
import { Card } from '../../../Shared/UI/Card';
import ChargebackReasonLabel from '../../Payments/ChargebackReasonLabel';
import { Donation, SharedProps, Subscription } from '../../types';
import Container from '../../UI/Container';
import Layout from '../../UI/Layout';
import PaymentStatusLabel from '../PaymentStatusLabel';
import { SubscriptionLayout } from './SubscriptionLayout';

export interface PaymentsPageProps extends SharedProps {
  subscription: Subscription;
  donations: (Donation & {
    payment: Payment;
    iban: string | null;
  })[];
}

export default function PaymentsPage({
  donations,
}: PaymentsPageProps) {
  const { t } = useTranslation();
  const { formatCurrency, formatDate } = useLocale();

  return (
    <Container className="space-y-6">
      <Card panels spacing="sm">
        {donations.map((donation) => (
          <div className="grid grid-cols-[2fr_3fr_1fr_2fr] !py-4 items-center" key={donation.id}>
            <div className="font-medium">
              {formatCurrency(donation.amount)}
            </div>
            <div className="text-slate-500">
              {donation.iban}
            </div>
            <div className="text-slate-500">
              {formatDate(donation.created_at)}
            </div>
            <div className="text-right">
              {donation.payment.chargeback_reason && (
                <ChargebackReasonLabel reason={donation.payment.chargeback_reason} />
              )}
              {!donation.payment.chargeback_reason && (
                <PaymentStatusLabel payment={donation.payment} />
              )}
            </div>
          </div>
        ))}
        {donations.length === 0 && (
          <div className="py-24 text-center text-slate-500">
            {t('backend:no_results')}
          </div>
        )}
      </Card>
    </Container>
  );
}

PaymentsPage.layout = (page: ReactNode) => <Layout><SubscriptionLayout>{page}</SubscriptionLayout></Layout>;
